var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_3350)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0712 0H18.9288C8.47469 0 0 8.47469 0 18.9288V40.0712C0 50.5253 8.47469 59 18.9288 59H40.0712C50.5253 59 59 50.5253 59 40.0712V18.9288C59 8.47469 50.5253 0 40.0712 0Z",
    fill: "url(#paint0_radial_15_3350)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15_3350)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6978 10C31.6978 16.9414 37.2648 22.5681 44.1325 22.5681C37.2648 22.5681 31.6978 28.1948 31.6978 35.1362C31.6978 28.1948 26.1308 22.5681 19.2631 22.5681C26.1308 22.5681 31.6978 16.9414 31.6978 10Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_3350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 10,
    width: 26,
    height: 26
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6978 10C31.6978 16.9414 37.2648 22.5681 44.1325 22.5681C37.2648 22.5681 31.6978 28.1948 31.6978 35.1362C31.6978 28.1948 26.1308 22.5681 19.2631 22.5681C26.1308 22.5681 31.6978 16.9414 31.6978 10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_3350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1349 10H39.1596V35.1386H44.1349V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1596 10H34.1843V35.1386H39.1596V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1867 10H29.2114V35.1386H34.1867V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2113 10H24.236V35.1386H29.2113V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.236 10H19.2607V35.1386H24.236V10Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7838 27.5847C42.7838 31.0566 45.5673 33.87 49.0024 33.87C45.5673 33.87 42.7838 36.6833 42.7838 40.1553C42.7838 36.6833 40.0004 33.87 36.5653 33.87C40.0004 33.87 42.7838 31.0566 42.7838 27.5847Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15_3350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 27,
    width: 14,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7838 27.5847C42.7838 31.0566 45.5673 33.87 49.0024 33.87C45.5673 33.87 42.7838 36.6833 42.7838 40.1553C42.7838 36.6833 40.0004 33.87 36.5653 33.87C40.0004 33.87 42.7838 31.0566 42.7838 27.5847Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15_3350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 27.5847H46.5135V40.1528H49V27.5847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5136 27.5847H44.0271V40.1528H46.5136V27.5847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.027 27.5847H41.5406V40.1528H44.027V27.5847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5382 27.5847H39.0518V40.1528H41.5382V27.5847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0518 27.5847H36.5653V40.1528H39.0518V27.5847Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6501 37.7147C33.6501 39.4507 35.0418 40.8574 36.7594 40.8574C35.0418 40.8574 33.6501 42.264 33.6501 44C33.6501 42.264 32.2584 40.8574 30.5408 40.8574C32.2584 40.8574 33.6501 39.4507 33.6501 37.7147Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15_3350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 37,
    width: 7,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6501 37.7147C33.6501 39.4507 35.0418 40.8574 36.7594 40.8574C35.0418 40.8574 33.6501 42.264 33.6501 44C33.6501 42.264 32.2584 40.8574 30.5408 40.8574C32.2584 40.8574 33.6501 39.4507 33.6501 37.7147Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15_3350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7593 37.7147H35.5161V44H36.7593V37.7147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5161 37.7147H34.2729V44H35.5161V37.7147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2729 37.7147H33.0297V44H34.2729V37.7147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0273 37.7147H31.7841V44H33.0273V37.7147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7841 37.7147H30.5408V44H31.7841V37.7147Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5839 41.1213V42.3754H10V41.1213H11.4085C11.672 41.1213 11.8636 41.0462 11.9858 40.8937C12.108 40.7412 12.1679 40.5136 12.1679 40.2085V30.1511C12.1679 29.8485 12.1056 29.6185 11.9858 29.4684C11.8636 29.3158 11.6696 29.2408 11.4085 29.2408H10V27.9866H15.7514V30.6935H15.8928C16.5323 29.8194 17.2965 29.1028 18.19 28.5435C19.0835 27.9842 20.1015 27.7034 21.2489 27.7034C22.7341 27.7034 23.8743 28.1319 24.6744 28.9866C25.4721 29.8412 25.8721 31.0663 25.8721 32.6619V40.24C25.8721 40.5451 25.9368 40.7678 26.0685 40.9107C26.2003 41.0535 26.3871 41.1237 26.6315 41.1237H28.0687V42.3779H20.4848V41.1237H21.443C21.6873 41.1237 21.8741 41.0487 22.0059 40.8961C22.1376 40.7436 22.2023 40.516 22.2023 40.211V32.1752C22.2023 31.3593 22.0083 30.7322 21.625 30.294C21.2394 29.8582 20.6621 29.6379 19.8907 29.6379C19.0451 29.6379 18.2786 29.9332 17.5935 30.5216C16.906 31.1099 16.3287 31.8314 15.8592 32.6861V40.2085C15.8592 40.5136 15.9239 40.7412 16.0556 40.8937C16.1874 41.0462 16.3742 41.1213 16.6186 41.1213H17.5767H17.5839Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15_3350",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56 46.5) rotate(-140.839) scale(62.55 38.0723)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D0A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#B367FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2247"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_3350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15_3350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 34,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.979fd29dc2f247ded0f97139f732f5b6.svg";
export { ForwardRef as ReactComponent };